import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IScenarioGroup } from '@api/types'
import { ScenarioGroupFragment } from '@api/fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        scenarioGroups: IScenarioGroup[]
      }
    }
  }
}

export default function list(): Promise<IScenarioGroup[]> {
  return client.gql.query({ query: scenarioGroupsQuery }).then(
    ({
      data: {
        viewer: {
          company: { scenarioGroups },
        },
      },
    }: IPayload) => scenarioGroups
  )
}

export const scenarioGroupsQuery = gql`
  query ScenarioGroups {
    viewer {
      company {
        scenarioGroups {
          ...ScenarioGroupFragment
        }
      }
    }
  }
  ${ScenarioGroupFragment}
`
